import React from 'react';

import IconAddFile from '@components/icons/IconAddFile';
import IconFile from '@components/icons/IconFile';
import IconCart3 from '@components/icons/IconCart3';
import IconCredits from '@components/icons/credits.icon';

const creditsCards = [
  {
    title: 'Available Credits',
    value: 0,
    hasLink: false,
    icon: <IconCredits size={48} />,
    data: 'creditsAvailable',
  },
  {
    title: 'Used Credits',
    value: 0,
    hasLink: false,
    icon: <IconFile size={48} />,
    data: 'creditsUsed',
  },
  {
    title: 'New Submission',
    value: '+++',
    hasLink: true,
    icon: <IconAddFile size={48} />,
    data: null,
    link: '/submissions/create',
  },

  {
    title: 'Add Credits',
    value: '+++',
    hasLink: true,
    icon: <IconCart3 size={48} />,
    data: null,
    link: '/orders/create',
  }
];

export default creditsCards;
